import { IConfirmationPopupDynamicProps } from "component-library";
import { IVideoOverlayPopupProps } from "shared/components/Video/VideoOverlayPopup/VideoOverlayPopup";

import { ActionType, IAction } from "store/types";

import { IErrorPopupDynamicProps } from "components/Popups/ErrorPopup/ErrorPopup";
import { IReportConcernPopupDynamicProps } from "components/Popups/ReportConcernPopup/ReportConcernPopup";

export enum PopupType {
  ErrorPopup,
  ReportConcernPopup,
  ConfirmationPopup,
  VideoOverlayPopup,
}

export interface IPopup {
  traceID?: string;
  type: PopupType;
  data?:
    | IErrorPopupDynamicProps
    | IReportConcernPopupDynamicProps
    | IConfirmationPopupDynamicProps
    | IVideoOverlayPopupProps;
}

export interface IUIState {
  popup: IPopup | null;
  locale: string;
  isLoading: boolean;
  isPageLoading: boolean;
}

// ============================== Actions Types =======================================================================

export type ShowPopup = (
  popupData: IPopup
) => IAction<ActionType.ShowPopup, IPopup>;

export type HidePopup = () => IAction<ActionType.HidePopup, undefined>;

export type SetLocale = (
  locale: string
) => IAction<ActionType.SetLocale, string>;

export type SetLoading = (
  value: boolean
) => IAction<ActionType.SetLoading, boolean>;

export type SetPageLoading = (
  value: boolean
) => IAction<ActionType.SetPageLoading, boolean>;

export type UIActionTypes =
  | ReturnType<ShowPopup>
  | ReturnType<HidePopup>
  | ReturnType<SetLocale>
  | ReturnType<SetLoading>
  | ReturnType<SetPageLoading>;
